import { render, staticRenderFns } from "./QuizVideo.vue?vue&type=template&id=0212ca17&scoped=true"
import script from "./QuizVideo.vue?vue&type=script&lang=js"
export * from "./QuizVideo.vue?vue&type=script&lang=js"
import style0 from "./QuizVideo.vue?vue&type=style&index=0&id=0212ca17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0212ca17",
  null
  
)

export default component.exports